// AUTO-GENERATED from packages/error-codes/errors.yaml — DO NOT EDIT MANUALLY
// Codegen: scripts/codegen/gen-error-codes.go
// SSOT: packages/error-codes/errors.yaml (version 1.0.0, 46 错误码)
// 规格: SPEC §4.4.3 / H-13 / H-ENG-13
// 禁止手写字面量错误码 — 必须使用本文件常量

/**
 * HSSNA 错误码枚举
 * 格式: HSSNA-<HTTP状态码>-<3位序号>
 * 命名: 将 code 中的连字符替换为下划线 (HSSNA-401-001 → HSSNA_401_001)
 */
export enum ErrorCode {
  // ===== 通用 (001-099) =====
  /** 参数校验失败 (HTTP 400) */
  HSSNA_400_001 = 'HSSNA-400-001',
  /** 未认证 (HTTP 401) */
  HSSNA_401_001 = 'HSSNA-401-001',
  /** 禁止访问 (HTTP 403) */
  HSSNA_403_001 = 'HSSNA-403-001',
  /** 家庭隔离越权 (HTTP 403) */
  HSSNA_403_002 = 'HSSNA-403-002',
  /** 资源不存在 (HTTP 404) */
  HSSNA_404_001 = 'HSSNA-404-001',
  /** 资源冲突 (HTTP 409) */
  HSSNA_409_001 = 'HSSNA-409-001',
  /** 重复 Idempotency-Key (HTTP 409) */
  HSSNA_409_003 = 'HSSNA-409-003',
  /** 业务规则违反 (HTTP 422) */
  HSSNA_422_001 = 'HSSNA-422-001',
  /** 业务规则违反 (HTTP 422) */
  HSSNA_422_005 = 'HSSNA-422-005',
  /** 跨分片事务禁止 (HTTP 422) */
  HSSNA_422_006 = 'HSSNA-422-006',
  /** 请求过多 (HTTP 429) */
  HSSNA_429_001 = 'HSSNA-429-001',
  /** 内部错误 (HTTP 500) */
  HSSNA_500_001 = 'HSSNA-500-001',
  /** 未捕获异常 (HTTP 500) */
  HSSNA_500_002 = 'HSSNA-500-002',
  /** 服务不可用 (HTTP 503) */
  HSSNA_503_001 = 'HSSNA-503-001',
  /** 审计链冻结 (HTTP 503) */
  HSSNA_503_002 = 'HSSNA-503-002',
  /** 网关超时 (HTTP 504) */
  HSSNA_504_001 = 'HSSNA-504-001',

  // ===== S1 Identity (100-199) =====
  /** JWT 无效或过期 (HTTP 401) */
  HSSNA_401_101 = 'HSSNA-401-101',
  /** Refresh Token 无效 (HTTP 401) */
  HSSNA_401_102 = 'HSSNA-401-102',
  /** 账号锁定 (HTTP 423) */
  HSSNA_423_101 = 'HSSNA-423-101',

  // ===== S2 Family (200-299) =====
  /** 家庭组不存在 (HTTP 404) */
  HSSNA_404_201 = 'HSSNA-404-201',
  /** 非家庭成员 (HTTP 403) */
  HSSNA_403_201 = 'HSSNA-403-201',

  // ===== S3 Vitals (300-399) =====
  /** LOINC 编码无效 (HTTP 422) */
  HSSNA_422_301 = 'HSSNA-422-301',
  /** UCUM 单位无效 (HTTP 422) */
  HSSNA_422_302 = 'HSSNA-422-302',
  /** 数据质量校验失败 (HTTP 422) */
  HSSNA_422_303 = 'HSSNA-422-303',

  // ===== S4 FHIR (400-499) =====
  /** FHIR Profile 校验失败 (HTTP 422) */
  HSSNA_422_401 = 'HSSNA-422-401',
  /** FHIR 资源版本冲突 (HTTP 409) */
  HSSNA_409_401 = 'HSSNA-409-401',
  /** FHIR 事务跨分片 (HTTP 422) */
  HSSNA_422_402 = 'HSSNA-422-402',

  // ===== S5 AI (500-599) =====
  /** AI 模型不可用 (HTTP 503) */
  HSSNA_503_501 = 'HSSNA-503-501',
  /** AI 置信度不足 (HTTP 200) */
  HSSNA_200_502 = 'HSSNA-200-502',
  /** 多模态数据缺失 (HTTP 422) */
  HSSNA_422_503 = 'HSSNA-422-503',

  // ===== S6 Stream (600-699) =====
  /** Flink 作业失败 (HTTP 500) */
  HSSNA_500_601 = 'HSSNA-500-601',

  // ===== S7 Alert (700-799) =====
  /** 无急救代呼授权 (HTTP 403) */
  HSSNA_403_701 = 'HSSNA-403-701',
  /** 告警不存在 (HTTP 404) */
  HSSNA_404_701 = 'HSSNA-404-701',
  /** 告警状态冲突 (HTTP 409) */
  HSSNA_409_701 = 'HSSNA-409-701',
  /** 升级规则无效 (HTTP 422) */
  HSSNA_422_701 = 'HSSNA-422-701',

  // ===== S8 CarePlan (800-899) =====
  /** 护理计划不存在 (HTTP 404) */
  HSSNA_404_801 = 'HSSNA-404-801',

  // ===== S9 Health (900-999) =====
  /** 健康档案不存在 (HTTP 404) */
  HSSNA_404_901 = 'HSSNA-404-901',

  // ===== S10 Device (101) =====
  /** 设备不存在 (HTTP 404) */
  HSSNA_404_101 = 'HSSNA-404-101',
  /** 设备已绑定 (HTTP 409) */
  HSSNA_409_101 = 'HSSNA-409-101',
  /** 设备证书无效 (HTTP 422) */
  HSSNA_422_101 = 'HSSNA-422-101',

  // ===== S11 Notify (111-112) =====
  /** 通知渠道不可用 (HTTP 503) */
  HSSNA_503_111 = 'HSSNA-503-111',
  /** 通知频率超限 (HTTP 429) */
  HSSNA_429_111 = 'HSSNA-429-111',
  /** 通知模板渲染失败 (HTTP 422) */
  HSSNA_422_112 = 'HSSNA-422-112',

  // ===== S12 Audit (121-131) =====
  /** Consent 未授权 (HTTP 403) */
  HSSNA_403_131 = 'HSSNA-403-131',
  /** 审计链断裂 (HTTP 503) */
  HSSNA_503_122 = 'HSSNA-503-122',
  /** 数据销毁请求无效 (HTTP 422) */
  HSSNA_422_121 = 'HSSNA-422-121',
}

/**
 * 错误码定义条目
 */
export interface ErrorDefinition {
  /** 错误码字面量 */
  code: ErrorCode;
  /** 错误标题 (中文) */
  title: string;
  /** HTTP 状态码 */
  status: number;
  /** 错误详情 (中文) */
  detail: string;
}

/**
 * 全部错误码定义 (SSOT 镜像)
 * 键为 ErrorCode 枚举值,值为完整定义
 */
export const ERROR_DEFINITIONS: Record<ErrorCode, ErrorDefinition> = {
  [ErrorCode.HSSNA_400_001]: {
    code: ErrorCode.HSSNA_400_001,
    title: '参数校验失败',
    status: 400,
    detail: '请求参数不符合 schema 校验规则',
  },
  [ErrorCode.HSSNA_401_001]: {
    code: ErrorCode.HSSNA_401_001,
    title: '未认证',
    status: 401,
    detail: '缺少或无效的认证凭证',
  },
  [ErrorCode.HSSNA_403_001]: {
    code: ErrorCode.HSSNA_403_001,
    title: '禁止访问',
    status: 403,
    detail: '无权限访问该资源',
  },
  [ErrorCode.HSSNA_403_002]: {
    code: ErrorCode.HSSNA_403_002,
    title: '家庭隔离越权',
    status: 403,
    detail: '跨家庭数据访问被拒绝 (NF-SEC-04)',
  },
  [ErrorCode.HSSNA_404_001]: {
    code: ErrorCode.HSSNA_404_001,
    title: '资源不存在',
    status: 404,
    detail: '请求的资源未找到',
  },
  [ErrorCode.HSSNA_409_001]: {
    code: ErrorCode.HSSNA_409_001,
    title: '资源冲突',
    status: 409,
    detail: '资源已存在或版本冲突',
  },
  [ErrorCode.HSSNA_409_003]: {
    code: ErrorCode.HSSNA_409_003,
    title: '重复 Idempotency-Key',
    status: 409,
    detail: '幂等键重复',
  },
  [ErrorCode.HSSNA_422_001]: {
    code: ErrorCode.HSSNA_422_001,
    title: '业务规则违反',
    status: 422,
    detail: '请求语义正确但违反业务规则',
  },
  [ErrorCode.HSSNA_422_005]: {
    code: ErrorCode.HSSNA_422_005,
    title: '业务规则违反',
    status: 422,
    detail: '操作不符合业务约束',
  },
  [ErrorCode.HSSNA_422_006]: {
    code: ErrorCode.HSSNA_422_006,
    title: '跨分片事务禁止',
    status: 422,
    detail: 'FHIR transaction 所有资源 family_group_id 必须相同 (C-DB-01)',
  },
  [ErrorCode.HSSNA_429_001]: {
    code: ErrorCode.HSSNA_429_001,
    title: '请求过多',
    status: 429,
    detail: '触发限流',
  },
  [ErrorCode.HSSNA_500_001]: {
    code: ErrorCode.HSSNA_500_001,
    title: '内部错误',
    status: 500,
    detail: '服务器内部错误',
  },
  [ErrorCode.HSSNA_500_002]: {
    code: ErrorCode.HSSNA_500_002,
    title: '未捕获异常',
    status: 500,
    detail: 'panic 兜底 (H-ENG-05)',
  },
  [ErrorCode.HSSNA_503_001]: {
    code: ErrorCode.HSSNA_503_001,
    title: '服务不可用',
    status: 503,
    detail: '服务暂时不可用',
  },
  [ErrorCode.HSSNA_503_002]: {
    code: ErrorCode.HSSNA_503_002,
    title: '审计链冻结',
    status: 503,
    detail: '审计哈希链断裂, 写入已冻结 (H-SEC-05)',
  },
  [ErrorCode.HSSNA_504_001]: {
    code: ErrorCode.HSSNA_504_001,
    title: '网关超时',
    status: 504,
    detail: '请求超时',
  },
  [ErrorCode.HSSNA_401_101]: {
    code: ErrorCode.HSSNA_401_101,
    title: 'JWT 无效或过期',
    status: 401,
    detail: 'JWT 令牌无效或已过期',
  },
  [ErrorCode.HSSNA_401_102]: {
    code: ErrorCode.HSSNA_401_102,
    title: 'Refresh Token 无效',
    status: 401,
    detail: 'Refresh token 已失效或被盗用',
  },
  [ErrorCode.HSSNA_423_101]: {
    code: ErrorCode.HSSNA_423_101,
    title: '账号锁定',
    status: 423,
    detail: '连续 5 次失败, 账号锁定 15 分钟 (H-SEC-02)',
  },
  [ErrorCode.HSSNA_404_201]: {
    code: ErrorCode.HSSNA_404_201,
    title: '家庭组不存在',
    status: 404,
    detail: '指定的家庭组未找到',
  },
  [ErrorCode.HSSNA_403_201]: {
    code: ErrorCode.HSSNA_403_201,
    title: '非家庭成员',
    status: 403,
    detail: '用户不属于该家庭组',
  },
  [ErrorCode.HSSNA_422_301]: {
    code: ErrorCode.HSSNA_422_301,
    title: 'LOINC 编码无效',
    status: 422,
    detail: '体征数据 LOINC 编码不在有效范围内',
  },
  [ErrorCode.HSSNA_422_302]: {
    code: ErrorCode.HSSNA_422_302,
    title: 'UCUM 单位无效',
    status: 422,
    detail: '体征数据 UCUM 单位不合规',
  },
  [ErrorCode.HSSNA_422_303]: {
    code: ErrorCode.HSSNA_422_303,
    title: '数据质量校验失败',
    status: 422,
    detail: '体征数据质量评分低于阈值',
  },
  [ErrorCode.HSSNA_422_401]: {
    code: ErrorCode.HSSNA_422_401,
    title: 'FHIR Profile 校验失败',
    status: 422,
    detail: 'FHIR 资源不符合 Profile 约束',
  },
  [ErrorCode.HSSNA_409_401]: {
    code: ErrorCode.HSSNA_409_401,
    title: 'FHIR 资源版本冲突',
    status: 409,
    detail: 'FHIR 资源版本号冲突 (乐观锁)',
  },
  [ErrorCode.HSSNA_422_402]: {
    code: ErrorCode.HSSNA_422_402,
    title: 'FHIR 事务跨分片',
    status: 422,
    detail: 'FHIR transaction 资源跨 family_group_id (C-DB-01)',
  },
  [ErrorCode.HSSNA_503_501]: {
    code: ErrorCode.HSSNA_503_501,
    title: 'AI 模型不可用',
    status: 503,
    detail: 'AI 推理模型不可用或加载失败',
  },
  [ErrorCode.HSSNA_200_502]: {
    code: ErrorCode.HSSNA_200_502,
    title: 'AI 置信度不足',
    status: 200,
    detail: 'AI 置信度低于阈值,已转人工复核 (F-JUD-05)',
  },
  [ErrorCode.HSSNA_422_503]: {
    code: ErrorCode.HSSNA_422_503,
    title: '多模态数据缺失',
    status: 422,
    detail: '多模态融合所需数据源缺失',
  },
  [ErrorCode.HSSNA_500_601]: {
    code: ErrorCode.HSSNA_500_601,
    title: 'Flink 作业失败',
    status: 500,
    detail: 'Flink 流处理作业异常',
  },
  [ErrorCode.HSSNA_403_701]: {
    code: ErrorCode.HSSNA_403_701,
    title: '无急救代呼授权',
    status: 403,
    detail: '用户未预先授权 120 代呼 (USR-10)',
  },
  [ErrorCode.HSSNA_404_701]: {
    code: ErrorCode.HSSNA_404_701,
    title: '告警不存在',
    status: 404,
    detail: '指定的告警未找到',
  },
  [ErrorCode.HSSNA_409_701]: {
    code: ErrorCode.HSSNA_409_701,
    title: '告警状态冲突',
    status: 409,
    detail: '告警当前状态不允许此操作',
  },
  [ErrorCode.HSSNA_422_701]: {
    code: ErrorCode.HSSNA_422_701,
    title: '升级规则无效',
    status: 422,
    detail: '告警升级规则配置无效',
  },
  [ErrorCode.HSSNA_404_801]: {
    code: ErrorCode.HSSNA_404_801,
    title: '护理计划不存在',
    status: 404,
    detail: '指定的护理计划未找到',
  },
  [ErrorCode.HSSNA_404_901]: {
    code: ErrorCode.HSSNA_404_901,
    title: '健康档案不存在',
    status: 404,
    detail: '指定的健康档案未找到',
  },
  [ErrorCode.HSSNA_404_101]: {
    code: ErrorCode.HSSNA_404_101,
    title: '设备不存在',
    status: 404,
    detail: '指定的设备未找到',
  },
  [ErrorCode.HSSNA_409_101]: {
    code: ErrorCode.HSSNA_409_101,
    title: '设备已绑定',
    status: 409,
    detail: '设备已绑定到其他患者',
  },
  [ErrorCode.HSSNA_422_101]: {
    code: ErrorCode.HSSNA_422_101,
    title: '设备证书无效',
    status: 422,
    detail: '设备 mTLS 证书无效或已撤销 (H-SEC-11)',
  },
  [ErrorCode.HSSNA_503_111]: {
    code: ErrorCode.HSSNA_503_111,
    title: '通知渠道不可用',
    status: 503,
    detail: '指定的通知渠道暂时不可用',
  },
  [ErrorCode.HSSNA_429_111]: {
    code: ErrorCode.HSSNA_429_111,
    title: '通知频率超限',
    status: 429,
    detail: '通知发送频率超过配额限制',
  },
  [ErrorCode.HSSNA_422_112]: {
    code: ErrorCode.HSSNA_422_112,
    title: '通知模板渲染失败',
    status: 422,
    detail: '通知模板变量缺失或格式错误',
  },
  [ErrorCode.HSSNA_403_131]: {
    code: ErrorCode.HSSNA_403_131,
    title: 'Consent 未授权',
    status: 403,
    detail: '数据主体未授权访问 L3/L4 数据 (H-SEC-13)',
  },
  [ErrorCode.HSSNA_503_122]: {
    code: ErrorCode.HSSNA_503_122,
    title: '审计链断裂',
    status: 503,
    detail: '审计哈希链断裂,写入已冻结 (H-SEC-05)',
  },
  [ErrorCode.HSSNA_422_121]: {
    code: ErrorCode.HSSNA_422_121,
    title: '数据销毁请求无效',
    status: 422,
    detail: '数据销毁请求不符合法规要求',
  },
};

/**
 * 全部错误码列表 (46 项)
 */
export const ALL_ERROR_CODES: readonly ErrorCode[] = Object.freeze(
  Object.values(ErrorCode),
);

/**
 * 按 ErrorCode 取其定义
 * SSOT 已覆盖全部 ErrorCode,本函数始终返回有效定义 (供 noUncheckedIndexedAccess 场景下安全访问)
 */
export function getErrorDefinition(code: ErrorCode): ErrorDefinition {
  return ERROR_DEFINITIONS[code]!;
}
